import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import agent from "../api/agent";
import { ApiRequestStatus } from "../enums/apiRequestStatus";
import { PersonDto } from "../models/personalDetails/personDto";

interface personDataState {
    personalDetails: PersonDto | null;
    personalDetailsList: PersonDto[] | null;
    
    personalDetailsStatus: ApiRequestStatus;
    personalDetailsListStatus: ApiRequestStatus;
}

const initialState: personDataState = {
    personalDetails: null,
    personalDetailsList: null,

    personalDetailsStatus: ApiRequestStatus.Idle,
    personalDetailsListStatus: ApiRequestStatus.Idle
}

export const getPersonalDetailsAsync = createAsyncThunk<PersonDto, string>(
    'personSlice/getPersonalDetailsAsync',
    async (personId, thunkAPI) => {
        try {
            return agent.person.getPersonalDetailsAsync(personId);
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ error: error.data });
        }
    }
)

export const getPersonalDetailsByImcnumbersAsync = createAsyncThunk<PersonDto[], string[]>(
    'personSlice/getPersonalDetailsByImcnumbersAsync',
    async (imcNumbers, thunkAPI) => {
        try {
            return agent.person.getPersonalDetailsByImcnumbersAsync(imcNumbers);
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ error: error.data });
        }
    }
)

export const personSlice = createSlice({
    name: 'personSlice',
    initialState,
    reducers: {

    },
    extraReducers: (builder => {
        builder.addCase(getPersonalDetailsAsync.pending, (state) => {
            state.personalDetailsStatus = ApiRequestStatus.Pending;
        });

        builder.addCase(getPersonalDetailsAsync.fulfilled, (state, action) => {
            state.personalDetails = action.payload;
            state.personalDetailsStatus = ApiRequestStatus.Fulfilled;
        });

        builder.addCase(getPersonalDetailsAsync.rejected, (state) => {
            state.personalDetailsStatus = ApiRequestStatus.Rejected;
        });

        builder.addCase(getPersonalDetailsByImcnumbersAsync.pending, (state) => {
            state.personalDetailsListStatus = ApiRequestStatus.Pending;
        });

        builder.addCase(getPersonalDetailsByImcnumbersAsync.fulfilled, (state, action) => {
            state.personalDetailsList = action.payload;
            state.personalDetailsListStatus = ApiRequestStatus.Fulfilled;
        });

        builder.addCase(getPersonalDetailsByImcnumbersAsync.rejected, (state) => {
            state.personalDetailsListStatus = ApiRequestStatus.Rejected;
        });
    })
})
